/* eslint-disable jsx-a11y/alt-text */
import { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import styles from './SliderNews.module.scss';
// import image from '../../../images/logo-blue.svg';
import { isMobile } from 'react-device-detect';

const SliderNews = ({ item, openFullScreenImg }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const mainSliderRef = useRef(null);
  const navSliderRef = useRef(null);
  const windowWidth = window.innerWidth;

  // Синхронизация слайдеров
  useEffect(() => {
    if (mainSliderRef.current && navSliderRef.current) {
      mainSliderRef.current.slickGoTo(currentSlide);
      navSliderRef.current.slickGoTo(currentSlide);
    }
  }, [currentSlide]);

  const handleBeforeChange = (_, nextSlide) => {
    setCurrentSlide(nextSlide);
  };

  const sliderSettings = {
    mainSlider: {
      arrows: !isMobile,
      adaptiveHeight: true,
      beforeChange: handleBeforeChange,
    },
    navSlider: {
      slidesToShow: windowWidth > 768 && windowWidth < 1001 ? Math.min(item.length, 6) : Math.min(item.length, 3),
      swipeToSlide: true,
      focusOnSelect: true,
      arrows: false,
      dots: isMobile,
      beforeChange: handleBeforeChange,
      className: item.length >= 3 ? 'center' : 'slider variable-width',
      variableWidth: item.length < 3,
      centerMode: item.length >= 3,
      centerPadding: item.length >= 3 ? (isMobile ? -17 : -5) : 10,
      appendDots: (dots) => (
        <div style={{ bottom: '-50px' }}>
          <ul style={{ margin: '0px' }}>{dots}</ul>
        </div>
      ),
      customPaging: (i) => (
        <div
          style={{
            width: 11,
            height: 11,
            border: `1px solid ${i === currentSlide ? '#00405B' : '#FF2E17'}`,
            borderRadius: '50%',
            backgroundColor: i === currentSlide ? '#00405B' : 'transparent',
          }}
        />
      ),
    },
  };

  const renderSlideContent = (item, index) => {
    // const isTablet = windowWidth > 768 && windowWidth < 1001;

    // const slideStyle = !isMobile
    //   ? {
    //       width: '100%',
    //       height: 'auto',
    //       aspectRatio: '4/3',
    //       backgroundImage: `url(${item.cropped_image})`,
    //     }
    //   : isTablet
    //   ? {
    //       width: '100%',
    //       aspectRatio: '4/3',
    //       height: 'auto',
    //       backgroundImage: `url(${item.image})`,
    //     }
    //   : {
    //       width: '100%',
    //       aspectRatio: '4/3',
    //       height: 'auto',
    //       backgroundImage: `url(${item.cropped_image})`,
    //     };

    return (
      <div key={index} onClick={() => openFullScreenImg(item)}>
        <img src={item.image} style={{ aspectRatio: '4/3', width: '100%', height: 'auto', objectFit: 'cover' }} />
      </div>
    );
  };

  const renderNavSlide = (point, index) => {
    // const slideStyle = !isMobile
    //   ? {
    //       width: 90,
    //       height: 90,
    //     }
    //   : {
    //       width: 77,
    //       height: 77,
    //     };

    return (
      <div key={index} style={{ width: 100 }}>
        <img src={point.cropped_image} />
      </div>
    );
  };

  return (
    <div className={styles.slider} id="newsSlider">
      {/* Main Slider */}
      <Slider ref={mainSliderRef} {...sliderSettings.mainSlider}>
        {item && item.map(renderSlideContent)}
      </Slider>

      {/* Decorative Image */}
      {/* <img
        src={image}
        className={styles.decorImgae}
        style={isMobile ? (windowWidth > 768 ? { top: '341px' } : { top: '121px' }) : { top: '188px' }}
      /> */}

      {/* Navigation Slider */}
      {item.length > 1 && (
        <Slider ref={navSliderRef} {...sliderSettings.navSlider}>
          {item && item.map(renderNavSlide)}
        </Slider>
      )}
    </div>
  );
};

export default SliderNews;
